import { Injectable } from '@angular/core';
import { Route, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, UrlSegment } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { AuthService, StorageService } from 'src/app/shared/service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private auth: Auth0Service,
    private authService: AuthService,
    private storageService: StorageService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   // const authenticate = this.authService.checkAuth();
    return this.auth.idTokenClaims$.pipe(map((res: any) => {
      if (res) {
        this.storageService.setItem('token', res.__raw);
        this.storageService.setItem('email', res.email);
      }
      return true;
    }), catchError((error) => {
      return of(false);
    }));
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const authenticate = this.authService.checkAuth();
    if (!authenticate) {
      this.authService.logoutRedirect();
    }
    return authenticate;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authenticate = this.authService.checkAuth();
    if (!authenticate) {
      this.authService.logoutRedirect();
    }
    return authenticate;
  }
}
